import { DocumentsAttributes, PublicationsAttributes } from "../../../../../contexts/krFormContext"
import { AuthorInstitutionAttributes, AuthorsAttributes, InstitutionsAttributes } from "../../../../../contexts/poFormContext"

export type DictionaryProposalDetails = {
    dictProposals?: DictionaryProposal[],
    authorsDictProposals?: AuthorsAttributes[],
    institutionsDictProposals?: InstitutionsAttributes[],
    authorInstitutionDictProposals?: AuthorInstitutionAttributes[],
    documentsDictProposals?: DocumentsAttributes[],
    publicationsDictProposals?: PublicationsAttributes[],
    authorsDict?: AuthorsAttributes[],
    institutionsDict?: InstitutionsAttributes[],
}

export type DictionaryProposal = {
    id: number,
    slowniK_NAZWA_DOM?: string,
    zglaszajacy?: string
    datA_ZGLOSZENIA?: any
}

export type DictionaryProposalOverview = {
    date?: Date | string,
    userName?: string,
    dictName?: DictProposalType,
    description?: string,
    proposalObject?: DictionaryProposal,
    detailObject?: any
}

export enum DictProposalType {
    Author = "Autor",
    Institution = "Instytucja",
    AuthorInstitution = "Powiązanie Autor-Instytucja",
    Document = "Dokumenty SOPO",
    Publication = "Publikacje SOPO"
}

export enum DictProposalTypeDbName {
    Author = "autor",
    Institution = "instytucja",
    AuthorInstitution = "powiazanieAutorInstytucja",
    Document = "dokumentySOPO",
    Publication = "publikacjeSOPO"
}

export enum DictProposalActions {
    Approve,
    Reject
}